export default {
  'examBookletPrint.downloadDocsError': 'Kitapçıkları indirirken bir hata oldu.',
};
